const initFaq = (section) => {
	section.querySelectorAll(".faq__toggle").forEach((button) => {
		button.addEventListener("click", () => {
			const item = button.closest(".faq__item");
			const panel = item?.querySelector(".faq__panel");
			const open = button.getAttribute("aria-expanded") === "true";

			section.querySelectorAll(".faq__item").forEach((other) => {
				const otherBtn = other.querySelector(".faq__toggle");
				const otherPanel = other.querySelector(".faq__panel");
				other.classList.remove("is-open");
				otherBtn?.setAttribute("aria-expanded", "false");
				otherPanel?.setAttribute("aria-hidden", "true");
			});

			if (!open && panel) {
				item.classList.add("is-open");
				button.setAttribute("aria-expanded", "true");
				panel.setAttribute("aria-hidden", "false");
			}
		});
	});
};

const boot = () => {
	document.querySelectorAll(".faq").forEach((section) => {
		initFaq(section);
	});
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
